import $ from 'jquery';
import moment from 'moment';
import DateRangePicker from 'bootstrap-daterangepicker';
import lang from '../lang';

const separator = ' - ';

const allLocales = {
    fr: {
        applyLabel: 'Fermer',
        cancelLabel: 'Annuler',
        customRangeLabel: 'Intervalle personnalisé',
        placeholder: {
            date: 'JJ/MM/AAAA',
            datetime: 'JJ/MM/AAAA HH:MM',
        },
    },
};

const defaultLocale = allLocales[lang];

const ExtendedDateRangePicker = function ($input, options, callback) {
    const picker = this;

    options = {
        autoApply: true,
        autoUpdateInput: false,
        showDropdowns: true,
        timePicker24Hour: true,
        drops: $('body').height() - $input.offset().top < 350 ? 'up' : 'down',
        ...$input.data(),
        ...options ?? {},
    };

    options.locale = {
        format: options.timePicker ? 'L LT' : 'L',
        separator: separator,
        ...defaultLocale,
        ...options.locale ?? {},
    };

    DateRangePicker.call(this, $input, options, callback);

    if (! picker.startDate || ! picker.startDate.isValid()) {
        picker.setStartDate(moment());
    }

    // Init placeholder and mask
    let placeholder = options.locale.placeholder[options.timePicker ? 'datetime' : 'date'],
        mask = moment('20991231T2359').format(options.locale.format).replace(/[0-9]/g, '0');

    if (! options.singleDatePicker) {
        placeholder += options.locale.separator + placeholder;
        mask += options.locale.separator + mask;
    }

    $input
        .attr('placeholder', placeholder)
        .mask(mask)
        .off('change.mask blur.mask')
        .on({
            'focusout.extendedDateRangePicker': function (event) {
                if (event.originalEvent) {
                    event.stopImmediatePropagation();
                }
            },
            'change.extendedDateRangePicker': function () {
                picker.elementChanged();
            },
        });
};

ExtendedDateRangePicker.prototype = Object.create(DateRangePicker.prototype);

ExtendedDateRangePicker.prototype.clickDate = function (e) {
    DateRangePicker.prototype.clickDate.call(this, e);

    this.updateInput();
};

ExtendedDateRangePicker.prototype.timeChanged = function (e) {
    DateRangePicker.prototype.timeChanged.call(this, e);

    if (this.endDate && this.maxSpan) {
        const maxDate = this.startDate.clone().add(this.maxSpan);
        if (this.endDate.isAfter(maxDate)) {
            this.setEndDate(maxDate)
        }
    }

    this.updateInput();
};

ExtendedDateRangePicker.prototype.hide = function (e) {
    DateRangePicker.prototype.hide.call(this, e);

    if (! this.autoApply) {
        this.element
            .trigger('focusout')
            .trigger('change');
    }
};

ExtendedDateRangePicker.prototype.updateInput = function () {
    let newValue = this.startDate.format(this.locale.format);

    if (! this.singleDatePicker) {
        newValue += this.locale.separator;

        if (this.endDate) {
            newValue += this.endDate.format(this.locale.format);
        }
    }

    if (newValue !== this.element.val()) {
        this.element
            .val(newValue)
            .trigger('input')
            .trigger('keyup');
    }

    if (this.autoApply) {
        this.element
            .trigger('focusout')
            .trigger('change');
    }
};

/**
 * @param {Object=} options
 * @param {function=} callback
 * @return {ExtendedDateRangePicker}
 */
$.fn.extendedDateRangePicker = function (options, callback) {
    this.each(function () {
        const $input = $(this);

        if (! $input.data('extendedDateRangePicker')) {
            $input.data('extendedDateRangePicker', new ExtendedDateRangePicker($input, options, callback));
        }
    });

    return this.data('extendedDateRangePicker');
};

/**
 * Initialize all date picker elements within a container.
 */
$.fn.datepickerContainerInit = function () {
    this.find('.daterangepicker').extendedDateRangePicker({
        singleDatePicker: false,
        timePicker: false,
    });

    this.find('.datetimerangepicker').extendedDateRangePicker({
        singleDatePicker: false,
        timePicker: true,
    });

    this.find('.datepicker').extendedDateRangePicker({
        singleDatePicker: true,
        timePicker: false,
    });

    this.find('.datetimepicker').extendedDateRangePicker({
        singleDatePicker: true,
        timePicker: true,
    });
};

/*
 * Initialize all date picker elements within document when ready.
 */
$(function () {
    $(document).datepickerContainerInit();
});
